export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/pptx.worker.cda6b685.worker.js");
}
